// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1YI64","title":"Images45_title__2VFTX","images":"Images45_images__2vGOS"};